(function FranchiseListReview($, Adzuki)
{
	'use strict';

	var form = {
		name: 'FranchiseListReview',
	};

	Adzuki.onload('FranchiseLists/review/');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load() 
	{
		$('.expand-right-sidebar-ajax').each(function _applyHighlight() {
			$(this).parent().css('color', '#333');
			$(this).parent().css('background-color', $(this).data('highlight'));
		});
	};
}(jQuery, window.Adzuki || {}));
